import { gql } from '@apollo/client'

export const FIND_CENTER_DOCUMENTS = gql`
  query findCenterDocuments(
    $query: String!, 
    $sort_by: String, 
    $sort_direction: String, 
    $offset: Int, 
    $limit: Int,
    $document_type: String,
    $created_at_start: String,
    $created_at_end: String,
    $sf_account_ids: [String!]!
  ) {
    centerDocuments: findCenterDocuments(
      query: $query, 
      sort_by: $sort_by, 
      sort_direction: $sort_direction, 
      offset: $offset, 
      limit: $limit,
      document_type: $document_type,
      created_at_start: $created_at_start,
      created_at_end: $created_at_end,
      sf_account_ids: $sf_account_ids
    ) {
      id
      name
      document_type
      content_type
      sf_account_ids
      file {
        url
        name
        size
      }
      count_sites
      count_accounts  
      accounts_summary {
        name
        sf_id
        sites {
          sf_id
          name  
        }
      }
      created_at
      updated_at
    }
  }
`

export const GET_CENTER_DOCUMENT = gql`
  query findCenterDocument($id: ID!) {
    document: findCenterDocument(id: $id) {
      id
      name
      document_type
      content_type
      sf_account_ids
      file {
        url
        size
      }
      created_at
      updated_at
      accounts: accounts_with_parent {
        name
        hierarchie
        sf_parent_id
        sf_id
        nb_children
        is_site
      }
      user {
        id
        email
        firstname
        lastname
      }
    }
  }
`

export const GET_CENTER_DOCUMENT_VIEWS = gql`
  query findCenterDocumentViews($id: ID!) {
    views: findCenterDocumentViews(id: $id) {
      activity_at
      user {
        id
        email
        firstname
        lastname
      }
    }
  }
`

export const GET_CENTER_DOCUMENT_DOWNLOAD = gql`
  query getCenterDocumentDownload($id: ID!) {
    getCenterDocumentDownload(id: $id) {
      url
    }
  }
`